import React from 'react';
import { useDetectTextOverflow } from 'application/hooks';
import VideoMediafilePoster from 'application/components/VideoMediafileItemPoster';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';

import styles from './index.module.scss';
import { TEXTS } from '../../../texts';

interface VideoMediafilePreviewItemContentProps {
  title?: string | null;
  duration?: number | null;
  imgLink?: string | null;
  uploading?: boolean;
  actionText?: string;
  actionHandler?: () => void;
  extension?: string | null;
}

const VideoMediafilePreviewItemContent: React.FC<VideoMediafilePreviewItemContentProps> = ({
  title,
  duration,
  imgLink,
  uploading,
  actionText,
  actionHandler,
  extension,
}) => {
  const descriptionText = uploading ? TEXTS.UPLOADING : undefined;

  const { isOverflow, textRef } = useDetectTextOverflow('[data-testid="video_media_title"]');

  return (
    <div className={styles.VideoMediafilePreviewItemContent}>
      <div className={styles.VideoMediafilePreviewItemContentPosterContainer}>
        <VideoMediafilePoster
          title={title}
          link={imgLink}
          uploading={uploading}
          duration={duration}
          extension={extension}
        />
      </div>

      <div
        ref={textRef}
        className={styles.VideoMediafilePreviewItemContentTextContainer}>
        <Popper
          placement={HintPlacement.PLACEMENT_TOP_START}
          containerClassName={styles.popper}
          isShow={isOverflow}
          offset={[10, 10]}
          triggerNode={
            <span
              data-testid="video_media_title"
              className={styles.VideoMediafilePreviewItemContentTextContainerTitle}>
              {title}
            </span>
          }>
          {title}
        </Popper>

        {descriptionText && (
          <p className={styles.VideoMediafilePreviewItemContentTextContainerDescription}>{descriptionText}</p>
        )}
        {actionText && (
          <Button
            className={styles.actionButton}
            elementId="video_media_action"
            type={ButtonType.PLAIN}
            onClick={actionHandler}>
            {actionText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default VideoMediafilePreviewItemContent;
